export const getSegmentPanelTitleId = (selectedSegmentId, segmentStatus) => {
    if (selectedSegmentId === null) {
        return 'newSegment';
    }
    if (segmentStatus === 'completed') {
        return 'finishedSegment';
    }
    return 'savedSegment';
};
const STORE_KEY = 'segmentSettings';
export const storeSegmentSettings = (formValues) => {
    const settings = {
        inputLanguage: formValues.inputLanguage,
        outputLanguages: formValues.outputLanguages,
        translationEnabled: formValues.translationEnabled,
        translationProfileId: formValues.translationProfileId,
        enableTTS: formValues.enableTTS,
        engineId: formValues.engineId,
        enableSpeechSegmentation: formValues.enableSpeechSegmentation,
    };
    localStorage.setItem(STORE_KEY, JSON.stringify(settings));
};
const firstProfileId = (profiles) => profiles[0]?.id ?? '';
export const blankFormValues = (config) => {
    const defaultEngine = config.s2tEngines.find((engine) => config.defaultEngineId === engine.id);
    return {
        title: '',
        description: '',
        inputLanguage: defaultEngine.defaultLanguage,
        outputLanguages: [],
        translationEnabled: false,
        translationProfileId: firstProfileId(config.translationProfiles),
        enableTTS: false,
        engineId: defaultEngine.id,
        enableSpeechSegmentation: true,
    };
};
export const formValuesFromSegment = (segment, base) => ({
    ...base,
    title: segment.title,
    description: '',
    inputLanguage: segment.audioLanguage,
    engineId: segment.engine,
    enableSpeechSegmentation: segment.speechSegmentation,
    translationEnabled: segment.translationSetup.languages.length > 0,
    outputLanguages: segment.translationSetup.languages.map((lang) => lang.iso),
    translationProfileId: segment.translationSetup.profileId ?? base.translationProfileId,
    enableTTS: segment.translationSetup.ttsEnabled ?? false,
});
export const safelyRestoreSegmentSettings = (config) => {
    const defaultEngine = config.s2tEngines.find((engine) => config.defaultEngineId === engine.id);
    const defaultProfileId = firstProfileId(config.translationProfiles);
    const defaultFormValues = blankFormValues(config);
    const storedSettingsItem = localStorage.getItem(STORE_KEY);
    if (storedSettingsItem === null) {
        return defaultFormValues;
    }
    try {
        const storedSettings = JSON.parse(storedSettingsItem);
        if (typeof storedSettings !== 'object' || storedSettings === null) {
            return defaultFormValues;
        }
        if ('inputLanguage' in storedSettings && typeof storedSettings.inputLanguage === 'string') {
            if (defaultEngine.languages.includes(storedSettings.inputLanguage)) {
                defaultFormValues.inputLanguage = storedSettings.inputLanguage;
            }
        }
        if ('outputLanguages' in storedSettings
            && Array.isArray(storedSettings.outputLanguages)
            && storedSettings.outputLanguages.every((lang) => typeof lang === 'string')) {
            const outputLanguages = storedSettings.outputLanguages.filter((lang) => config.outputLanguages.includes(lang) && lang !== defaultFormValues.inputLanguage);
            defaultFormValues.outputLanguages = outputLanguages;
        }
        if ('translationEnabled' in storedSettings && typeof storedSettings.translationEnabled === 'boolean') {
            defaultFormValues.translationEnabled = storedSettings.translationEnabled;
        }
        if ('translationProfileId' in storedSettings
            && typeof storedSettings.translationProfileId === 'string'
            && config.translationProfiles.some((p) => p.id === storedSettings.translationProfileId)) {
            defaultFormValues.translationProfileId = storedSettings.translationProfileId;
        }
        if ('enableTTS' in storedSettings && typeof storedSettings.enableTTS === 'boolean') {
            defaultFormValues.enableTTS = storedSettings.enableTTS;
        }
        if ('engineId' in storedSettings && typeof storedSettings.engineId === 'string') {
            const engine = config.s2tEngines.find((e) => e.id === storedSettings.engineId);
            if (engine !== undefined) {
                defaultFormValues.engineId = engine.id;
            }
        }
        if ('enableSpeechSegmentation' in storedSettings
            && typeof storedSettings.enableSpeechSegmentation === 'boolean') {
            defaultFormValues.enableSpeechSegmentation = storedSettings.enableSpeechSegmentation;
        }
    }
    catch (error) {
        console.error('Failed to read stored segment settings:', error);
        localStorage.removeItem(STORE_KEY);
        return defaultFormValues;
    }
    return defaultFormValues;
};
